import type { EntityType, ZweihanderEntityType } from './types'

/** All typed-5e entity types (Grymwyrd and similar SRD-based worlds). */
export const ENTITY_TYPES: EntityType[] = [
  'monster',
  'spell',
  'species',
  'character-class',
  'magic-item',
  'location',
  'scene',
  'trap',
  'equipment',
  'weapon',
  'armor',
  'skill',
  'table',
  'card',
  'deck',
  'character',
]

/** All Zweihänder system_entity types. */
export const ZWEIHANDER_ENTITY_TYPES: ZweihanderEntityType[] = [
  'ancestry',
  'profession',
  'archetype',
  'talent',
  'trait',
  'skill',
  'spell',
  'ritual',
  'trapping',
  'weapon',
  'armor',
  'creature',
  'condition',
  'disorder',
  'disease',
  'injury',
  'table',
]

/** Human-readable labels for all entity types. */
export const ENTITY_META: Record<string, { label: string; plural: string }> = {
  // Typed-5e types
  monster: { label: 'Monster', plural: 'Monsters' },
  spell: { label: 'Spell', plural: 'Spells' },
  species: { label: 'Species', plural: 'Species' },
  'character-class': { label: 'Class', plural: 'Classes' },
  'magic-item': { label: 'Magic Item', plural: 'Magic Items' },
  location: { label: 'Location', plural: 'Locations' },
  scene: { label: 'Scene', plural: 'Scenes' },
  trap: { label: 'Trap', plural: 'Traps' },
  equipment: { label: 'Equipment', plural: 'Equipment' },
  weapon: { label: 'Weapon', plural: 'Weapons' },
  armor: { label: 'Armor', plural: 'Armor' },
  skill: { label: 'Skill', plural: 'Skills' },
  table: { label: 'Table', plural: 'Tables' },
  card: { label: 'Card', plural: 'Cards' },
  deck: { label: 'Deck', plural: 'Decks' },
  character: { label: 'Character', plural: 'Characters' },
  // Zweihänder system_entity types
  ancestry: { label: 'Ancestry', plural: 'Ancestries' },
  profession: { label: 'Profession', plural: 'Professions' },
  archetype: { label: 'Archetype', plural: 'Archetypes' },
  talent: { label: 'Talent', plural: 'Talents' },
  trait: { label: 'Trait', plural: 'Traits' },
  ritual: { label: 'Ritual', plural: 'Rituals' },
  trapping: { label: 'Trapping', plural: 'Trappings' },
  creature: { label: 'Creature', plural: 'Creatures' },
  condition: { label: 'Condition', plural: 'Conditions' },
  disorder: { label: 'Disorder', plural: 'Disorders' },
  disease: { label: 'Disease', plural: 'Diseases' },
  injury: { label: 'Injury', plural: 'Injuries' },
}
